import React from 'react';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        style={{height: '100%', overflow: 'auto'}}
        {...other}
      >
          {children}
      </div>
    );
  }

  export {TabPanel};
  export {Tab, Tabs} from '@material-ui/core';
